var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TeacherCountCard',{staticClass:"mr-4",on:{"card-clicked":_vm.goToTeacher}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }